export default __webpack_public_path__ + "static/media/28_trian.69624611.JPG";